module.exports = __webpack_public_path__ + "img/mail.1a5d6c5f.svg";